import { render } from "./TheDuongPho.vue?vue&type=template&id=630ba4ee"
import script from "./TheDuongPho.vue?vue&type=script&lang=js"
export * from "./TheDuongPho.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__